import makeApiRequest from './makeApiCall';

export const getAdvancesFormCustomers = async (data) => {
  //endpoint => declaration of api
  return await makeApiRequest(`/advances-from-customers`, 'POST', null, data);
};

export const getAdvancesFormCustomersExport = async (data) => {
  //endpoint => declaration of api
  return await makeApiRequest(
    `/advances-from-customers/export`,
    'POST',
    null,
    data,
  );
};

export const getAdvancesFormCustomersJv = async (data) => {
  //endpoint => declaration of api
  return await makeApiRequest(
    `/advances-from-customers/jv`,
    'POST',
    null,
    data,
  );
};

export const getAdvancesFormCustomers2 = async (data) => {
  //endpoint => declaration of api
  return await makeApiRequest(`/advances/customers`, 'POST', null, data);
};

export const getAdvancesFromCustomersV2Summary = async (data) => {
  return await makeApiRequest(
    `/v2/advances/customers/summary`,
    'POST',
    null,
    data,
  );
};

export const getAdvancesFromCustomersV2Export = async (data) => {
  return await makeApiRequest(
    `/v2/advances/customers/export`,
    'POST',
    null,
    data,
  );
};

// Save / remove a manual entry that replaces the row of a JV or PV line with no
// set-up in the Advances from Customers sub-ledger. `source` is 'jv' or 'pv'.
export const saveAdvancesManualEntry = async (data) => {
  return await makeApiRequest(
    `/v2/advances/customers/manual-entries`,
    'POST',
    null,
    data,
  );
};

export const removeAdvancesManualEntry = async (data) => {
  return await makeApiRequest(
    `/v2/advances/customers/manual-entries/remove`,
    'POST',
    null,
    data,
  );
};

// A customer's live manual set-ups: what a manual reversal can be drawn against.
export const getAdvancesManualSetups = async (data) => {
  return await makeApiRequest(
    `/v2/advances/customers/manual-entries/setups`,
    'POST',
    null,
    data,
  );
};
